<div class="auth-layout">
  <div class="auth-layout_form">
    <router-outlet></router-outlet>
  </div>

  <div class="auth-layout_bg">
    <!-- <div class="auth-layout_bg__content">
      <ng-content select="[bgContent]"></ng-content>
    </div>
    <div class="auth-layout_bg__footer">
      <ng-content select="[bgFooter]"></ng-content>
    </div> -->

    <div class="auth-layout_bg__content">
      <div
        class="auth-layout_bg__content_header d-flex align-items-center my-3"
      >
        <div class="image">
          <img
            src="../../../../assets/images/Aquila_logo_modified@2x.png"
            alt="aquila-logo"
          />
        </div>
      </div>
      <p class="mb-1">
        TM Forum Open API Conformance & AI-Assisted Quality Engineering Platform
      </p>
      <span>
        API Conformance <span class="dot"></span> Centralized API Library
        <span class="dot"></span> AI-Assisted Quality
      </span>
    </div>

    <div class="auth-layout_bg__footer">
      <span class="mx-3">Developed by</span>
      <div>
        <img src="../../../../assets/images/qeema-logo.svg" alt="qeema-lpgo" />
      </div>
    </div>
  </div>
</div>
